/**
 * @desc 查询被冻结库位库存列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stockFreezeRecord.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/stockFreezeRecord/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
